exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.strong-on-hover:hover small,\r\n.strong-on-hover:hover .progress-bar {\r\n  font-weight: bold;\n}\r\n", ""]);

// exports
